import React, { useState} from "react";
import {IWishList} from "../../../interfaces";
import SelectWishList from "../select-list";
import {addItemToWishlist} from "../../../DAL/data-service";
import ItemAddedToList from "./item-added-to-list";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";

/**
 * on click "+ New List" - WishList menu
 */
const AddToExistingList: React.FC<{skuid:number,wishlists: IWishList[],showCreateNewlist:()=>void,hideAddToWishlistPopup:()=>void}> =
    ({skuid,wishlists,showCreateNewlist,hideAddToWishlistPopup}) =>  {
    const [addToWishList, setAddToWishList] = useState<IWishList | null>(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const AddToItemWishlist = async (toWishList:IWishList|null ,newWishlistName:string) => {
        let wishlist = toWishList !== null ? toWishList : {} as any;
        const response = await addItemToWishlist(skuid,wishlist.itemID,newWishlistName);
        if(response.statusCode !== 200) {
            setErrorMessage("An error has occurred.");
            return;
        }

        if(newWishlistName.length > 0){
            //if newWishlistName.length > 0 -> method addItemToWishlist creates new wishlist and add the item to it.
            sendGAEvent("Wish List","Create New Wish List");
        }

        let updatedWishlist  = response.data.relatedData as IWishList;

        if(updatedWishlist.itemID === 0){
            //when user tries to add an existing item -> wishlist is not changes
            setAddToWishList(toWishList);
        }else{
            //set updated wishlist for link
            setAddToWishList(updatedWishlist);
        }
        setShowSuccess(true);
    }
    return (
        <>
            {showSuccess ?
                <ItemAddedToList addToWishList={addToWishList}
                                 showCreateNewlist={showCreateNewlist}
                                 hideAddToWishlistPopup={hideAddToWishlistPopup} />
                :
                <SelectWishList
                    wishlists={wishlists}
                    hidePopup={hideAddToWishlistPopup}
                    errorMessage={errorMessage}
                    submit={AddToItemWishlist}
                />
            }
        </>
    )
};

export default AddToExistingList;